import { useEffect, useMemo, useState } from 'react';

const useCheckedRows = <T extends { id: string }>(rows: readonly T[]) => {
  const allIds = rows.map((r) => r.id);
  const [checked, setChecked] = useState<Set<string>>(() => new Set(allIds));

  useEffect(() => setChecked(new Set(allIds)), [allIds.length]); // TODO: try to remove it

  console.log('useCheckedRows - checked: ', checked);
  return { checkedRowIds: checked, setCheckedRowIds: setChecked } as const;
};

export default useCheckedRows;
